import { render, staticRenderFns } from "./DatasetOverview.vue?vue&type=template&id=4a1bc5d2&"
import script from "./DatasetOverview.vue?vue&type=script&lang=js&"
export * from "./DatasetOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports